// extracted by mini-css-extract-plugin
export default {"header":"Reservation_header__hvroO","title":"Reservation_title__XpElp","pink":"Reservation_pink__qgxFx"};